/**
 * General string utility functions.
 * These functions are designed to be reusable across different projects.
 */

/**
 * Converts a string to sentence case (first letter uppercase, rest lowercase).
 * @param {string} str - String to convert
 * @returns {string} String in sentence case
 * @example
 * toSentenceCase('HELLO WORLD') // 'Hello world'
 * toSentenceCase('hello world') // 'Hello world'
 */
export function toSentenceCase(str) {
    if (!str || str.length === 0) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Converts a string to title case (first letter of each word uppercase, rest lowercase).
 * @param {string} str - String to convert
 * @returns {string} String in title case
 * @example
 * toTitleCase('JANE AUSTEN') // 'Jane Austen'
 * toTitleCase('jane austen') // 'Jane Austen'
 * toTitleCase('jAnE aUsTeN') // 'Jane Austen'
 */
export function toTitleCase(str) {
    if (!str || str.length === 0) {
        return str;
    }
    return str.split(' ').map(toSentenceCase).join(' ');
}
